export default __webpack_public_path__ + "static/media/DSC_0564.6cd29bff.webp";